var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinuteur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 1.34228C12.375 0.600961 13.0046 0 13.7812 0H18H22.2187C22.9954 0 23.625 0.600961 23.625 1.34228C23.625 2.0836 22.9954 2.68456 22.2187 2.68456H19.4062V5.68918C22.4953 5.91702 25.366 6.88918 27.8213 8.41804C27.8764 8.34499 27.9383 8.27522 28.0069 8.20956L30.8194 5.52499C31.5059 4.86974 32.6188 4.86974 33.3053 5.52499C33.9919 6.18024 33.9919 7.24258 33.3053 7.89783L30.5634 10.515C33.9173 13.6356 36 17.995 36 22.8187C36 32.3077 27.9411 40 18 40C8.05884 40 0 32.3077 0 22.8187C0 13.7815 7.30985 6.37396 16.5937 5.68918V2.68456H13.7812C13.0046 2.68456 12.375 2.0836 12.375 1.34228ZM2.8125 22.8187C2.8125 14.8125 9.61215 8.32209 18 8.32209C26.3877 8.32209 33.1875 14.8125 33.1875 22.8187C33.1875 30.825 26.3877 37.3154 18 37.3154C9.61215 37.3154 2.8125 30.825 2.8125 22.8187ZM18 22.8187V11.0067C11.1654 11.0067 5.62499 16.2951 5.62499 22.8187C5.62499 29.3423 11.1654 34.6309 18 34.6309C21.4172 34.6309 24.511 33.3087 26.7503 31.171L18 22.8187Z",
    fill: "#6B716A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinuteur);
export default __webpack_public_path__ + "static/media/minuteur.52087bff4fb5f6e54ff81d8bc683ed00.svg";
export { ForwardRef as ReactComponent };